import React from 'react';
import { Routes, Route } from 'react-router-dom'; // Removed BrowserRouter alias Router
import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import Partners from './pages/Partners';
import Inquiries from './pages/Inquiries';
import SubmitInquiries from './pages/SubmitInquiries';
import Chat from './pages/Chat';

const App = () => {
    return (
        <div className="app-container flex flex-col min-h-screen">
            {/* Header */}
            <Header />

            {/* Main Content */}
            <main className="flex-1">
                <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/partners" element={<Partners />} />
                    <Route path="/inquiries" element={<Inquiries />} />
                    <Route path="/submit-inquiry" element={<SubmitInquiries />} />
                    <Route path="/chat" element={<Chat />} />
                    {/* Fallback Route */}
                    <Route path="*" element={<div>404 - Page Not Found</div>} />
                </Routes>
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default App;